import Helper from '../../../helpers/Helper';

export interface TooltipParamLike {
    seriesName?: string;
    color?: unknown;
    value?: unknown;
    axisValue?: unknown;
}

export interface TooltipSizeLike {
    contentSize: number[];
    viewSize: number[];
}

export const TOOLTIP_CLASS = 'chart-tooltip-single';

export const TOOLTIP_BASE = {
    appendToBody: true,
    confine: false,
    borderWidth: 0,
    borderColor: 'transparent',
    padding: 0,
    backgroundColor: 'transparent',
    extraCssText: 'box-shadow:none;',
    className: TOOLTIP_CLASS,
} as const;

export const tooltipRow = (color: unknown, label: string, value: string): string =>
    `<div class="d-flex justify-content-between"><div><div class="dot" style="background-color: ${color}"></div>${label}:</div> <span style="padding-left: 20px" class="value">${value}</span></div>`;

export const wrapTooltip = (timestamp: number, body: string): string =>
    `<div class="chart-tooltip-new"><div class="tooltip-header">${Helper.formatDate(timestamp).replace(' at', ',')}</div>${body}</div>`;

const pointValue = (value: unknown): unknown => (Array.isArray(value) ? value[1] : value);

const axisTime = (params: TooltipParamLike[]): number => {
    for (const param of params) {
        if (typeof param.axisValue === 'number') {
            return param.axisValue;
        }
        if (Array.isArray(param.value) && typeof param.value[0] === 'number') {
            return param.value[0];
        }
    }
    return NaN;
};

export const formatTimeSeriesTooltip = (
    params: TooltipParamLike | TooltipParamLike[],
    chartDataType: number,
    seriesOrder?: string[],
): string => {
    const list = Array.isArray(params) ? params : [params];

    const points = list
        .map(param => ({
            series: { name: param.seriesName ?? '' },
            color: param.color,
            y: pointValue(param.value),
        }))
        .filter(point => typeof point.y === 'number' && Number.isFinite(point.y));

    if (seriesOrder && seriesOrder.length) {
        const rankByName = new Map(seriesOrder.map((name, index) => [name, index]));
        const rank = (name: string) => rankByName.get(name) ?? Number.MAX_SAFE_INTEGER;
        points.sort((first, second) => rank(first.series.name) - rank(second.series.name));
    }

    if (points.length === 0) {
        return '';
    }

    return Helper.getChartTooltipsNew({ x: axisTime(list), points }, chartDataType);
};

export const positionTooltip = (
    point: number[],
    _params: unknown,
    _dom: unknown,
    _rect: unknown,
    size: TooltipSizeLike,
): number[] => {
    const [anchorX, anchorY] = point;
    const [labelWidth, labelHeight] = size.contentSize;
    const chartWidth = size.viewSize[0];

    const flipLeft = anchorX + labelWidth + 20 > chartWidth;
    const x = flipLeft ? anchorX - labelWidth - 10 : anchorX + 10;
    let y = anchorY - labelHeight - 10;

    if (y < 0) {
        y = anchorY + 10;
    }

    return [Math.max(x, 0), y];
};
